module.exports = __webpack_public_path__ + "img/steeringAngleHor-topNeedle.1bd77775.svg";